'use client';

import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { HealthArticle, HealthArticleValue } from '../../components/HealthArticle';
import { AnimalTypeSlug, HealthArticleType } from '../../constants/app';
import { WagContentApiEndpoint } from '../../constants/endpoints';
import { useGetArticleVetAdviceList } from '../../hooks/api/useGetArticleVetAdviceList';
import { Layout } from '../../components/Layout';
export type ConditionArticlePageContainerValue = HealthArticleValue;
type Props = {
  value: ConditionArticlePageContainerValue;
  metaTitle: string;
  slug: string;
  hasNextPage: boolean;
  nextPageUrl: string;
  vetAdviceUrl?: string;
  animalTypeSlug?: AnimalTypeSlug;
};
export const ConditionArticlePageContainer = ({
  value,
  metaTitle,
  slug,
  hasNextPage,
  nextPageUrl,
  vetAdviceUrl = WagContentApiEndpoint.GetConditionArticleBySlug,
  animalTypeSlug
}: Props) => {
  const {
    query: {
      page
    }
  } = useRouter();
  const {
    data: articleVetAdvice,
    isLoading,
    execute: getArticleVetAdviceList
  } = useGetArticleVetAdviceList({
    url: vetAdviceUrl,
    initialData: {
      adviceList: value.adviceList,
      healthExperienceList: value.healthExperienceList,
      hasNextPage
    },
    articleType: HealthArticleType.Condition,
    page: Number(page),
    slug
  });
  // TODO - extract to another hook or use context?
  const [adviceList, setAdviceList] = useState(articleVetAdvice.adviceList);

  // We need to have a `useEffect` because the initial value on the
  // `useState` will only run on initial render not on
  // subsequent render. Subsequent render = everytime we trigger pagination
  useEffect(() => {
    setAdviceList(articleVetAdvice.adviceList);
  }, [articleVetAdvice.adviceList, setAdviceList]);
  return <Layout data-sentry-element="Layout" data-sentry-component="ConditionArticlePageContainer" data-sentry-source-file="index.tsx">
      <HealthArticle value={{
      ...value,
      adviceList,
      healthExperienceList: articleVetAdvice.healthExperienceList
    }} articleType={HealthArticleType.Condition} metaTitle={metaTitle} hasNextPageVetAdvice={articleVetAdvice.hasNextPage} isFetchingVetAdvice={isLoading} slug={slug} nextPageUrl={nextPageUrl} updateAdviceList={setAdviceList} animalTypeSlug={animalTypeSlug} onClickSeeMoreVetAdviceButton={() => {
      // TODO - do we need to update the URL with the new page?
      getArticleVetAdviceList();
    }} data-sentry-element="HealthArticle" data-sentry-source-file="index.tsx" />
    </Layout>;
};
export type ConditionArticlePageContainerProps = Props;